var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-0"},[_vm._v("Reset password")]),_c('p',[_vm._v("Enter your username, reset code and new password.")]),_c('ResetPasswordForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }